var _require = require('lodash'),
    isNumber = _require.isNumber,
    chunk = _require.chunk,
    flatten = _require.flatten;

var Bluebird = require('bluebird');

module.exports = function batchInsert(client, tableName, batch) {
  var chunkSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

  var _returning = void 0;

  var autoTransaction = true;
  var transaction = null;

  var getTransaction = function getTransaction() {
    return new Bluebird(function (resolve, reject) {
      if (transaction) {
        autoTransaction = false;
        return resolve(transaction);
      }

      autoTransaction = true;
      client.transaction(resolve).catch(reject);
    });
  };

  var wrapper = Object.assign(new Bluebird(function (resolve, reject) {
    var chunks = chunk(batch, chunkSize);

    if (!isNumber(chunkSize) || chunkSize < 1) {
      return reject(new TypeError("Invalid chunkSize: ".concat(chunkSize)));
    }

    if (!Array.isArray(batch)) {
      return reject(new TypeError("Invalid batch: Expected array, got ".concat(typeof batch)));
    } //Next tick to ensure wrapper functions are called if needed


    return Bluebird.delay(1).then(getTransaction).then(function (tr) {
      return Bluebird.mapSeries(chunks, function (items) {
        return tr(tableName).insert(items, _returning);
      }).then(function (result) {
        result = flatten(result || []);

        if (autoTransaction) {
          //TODO: -- Oracle tr.commit() does not return a 'thenable' !? Ugly hack for now.
          return (tr.commit(result) || Bluebird.resolve()).then(function () {
            return result;
          });
        }

        return result;
      }).catch(function (error) {
        if (autoTransaction) {
          return tr.rollback(error).then(function () {
            return Bluebird.reject(error);
          });
        }

        return Bluebird.reject(error);
      });
    }).then(resolve).catch(reject);
  }), {
    returning: function returning(columns) {
      _returning = columns;
      return this;
    },
    transacting: function transacting(tr) {
      transaction = tr;
      return this;
    }
  });
  return wrapper;
};